exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vmp-quiz-select {\n  z-index: 3000 !important;\n  max-width: 100% !important;\n  position: absolute !important;\n  top: 35px !important;\n  left: 0 !important;\n  right: 0 !important;\n}\n.vmp-quiz-select .vh-select-dropdown__item {\n    white-space: normal;\n    line-height: 22px;\n    margin: 10px 0;\n    height: auto;\n}\n.vmp-quiz-select .vh-scrollbar .vh-scrollbar__bar {\n    opacity: 1 !important;\n    visibility: hidden;\n}\n", ""]);

// exports
